import { render, staticRenderFns } from "./Topic.vue?vue&type=template&id=5ccbfd9a&scoped=true&"
import script from "./Topic.vue?vue&type=script&lang=ts&"
export * from "./Topic.vue?vue&type=script&lang=ts&"
import style0 from "./Topic.vue?vue&type=style&index=0&id=5ccbfd9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccbfd9a",
  null
  
)

export default component.exports